import { Image } from "components";
import { Dispatch, FC, SetStateAction } from "react";

import { PropertySurveyEvidenceModal } from "../PropertySurveyEvidenceModal";
import ClosingDocsExample1 from "public/evidence-examples/closing-docs1.png";
import ClosingDocsExample2 from "public/evidence-examples/closing-docs2.png";
import ButtonV2 from "elements/ButtonV2";

export const EvidenceModal: FC<{
	setOpen: Dispatch<SetStateAction<boolean>>;
}> = ({ setOpen }) => {
	return (
		<PropertySurveyEvidenceModal onAttemptExit={() => setOpen(false)}>
			<p>
				<b>Closing Disclosure</b>
			</p>
			<div className="property-survey-evidence-modal-body-text-container">
				<p className="sm">
					If you recently purchased this property and the county assessor does
					not know the purchase price they will assume the purchase price is
					higher than your assessment. This makes it difficult or impossible to
					earn a tax reduction. By uploading your closing disclosure, we can
					fight to lower your assessment to your purchase price. We will never
					share documents with the assessor’s office that hurts your chance of a
					tax reduction.
				</p>
				<br />
				<p className="sm">
					<b>Uploaded closing disclosure must include:</b>
				</p>
				<ul>
					<li className="sm">
						<b>Property Purchase Price</b>
					</li>
					<li className="sm">
						<b>Dated</b>
					</li>
					<li className="sm">
						<b>Signature</b>
					</li>
					<li className="sm">
						<b>Realtor Commissions</b>
					</li>
				</ul>
			</div>
			<p>Example Documents & Photos</p>
			<div className="property-survey-evidence-modal-image-container">
				<Image
					// openInNewTab
					placeholder="blur"
					src={ClosingDocsExample1}
					alt="Closing disclosure documents example image"
				/>
				<Image
					// openInNewTab
					placeholder="blur"
					src={ClosingDocsExample2}
					alt="Second closing disclosure documents example image"
				/>
			</div>
			<ButtonV2
				size="mobile-extra-small"
				onClick={() => setOpen(false)}
				className="mx-auto">
				Back to Question
			</ButtonV2>
		</PropertySurveyEvidenceModal>
	);
};
